module.exports = __webpack_public_path__ + "static/image-privacity-1c00c99e56b824643cadf26a43bff374.jpg";